// extracted by mini-css-extract-plugin
export default {"container":"InfoLegal_container__xxl6+"};